export const streamRateLimitExceeded = 429;
export const streamQueryMessagesLimit = 300;
export const directMessageChannelType = "messaging";
export const teamChannelType = "team";
export const streamQueryUsersLimit = 100;
